import { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { ReactFacebookPixel, ReactFullstory, ReactGA } from '../../lib';
import { FacebookPixel } from './FacebookPixel';
import { GoogleAnalyticsTracking } from './GoogleAnalyticsTracking';
import { FullstoryTracking } from './FullstoryTracking';
import { LinkedInTracking } from './LinkedInTracking';

const Tracking = ({ location }) => {
  return (
    <Fragment>
      <ReactFacebookPixel>
        {({ default: facebook }) => (
          <FacebookPixel
            location={location}
            facebook={facebook} />
        )}
      </ReactFacebookPixel>
      <ReactGA>
        {({ initialize, pageview }) => (
          <GoogleAnalyticsTracking
            location={location}
            pageview={pageview}
            initialize={initialize} />
        )}
      </ReactGA>
      <ReactFullstory>
        {({ consent, default: component }) => (
          <FullstoryTracking
            location={location}
            component={component}
            consentFn={consent}
          />
        )}
      </ReactFullstory>
      <LinkedInTracking location={location} />
    </Fragment>
  )
}

export default withRouter(Tracking);